"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var at_png_1 = __importDefault(require("./flags/at.png"));
var au_png_1 = __importDefault(require("./flags/au.png"));
var be_png_1 = __importDefault(require("./flags/be.png"));
var br_png_1 = __importDefault(require("./flags/br.png"));
var ca_png_1 = __importDefault(require("./flags/ca.png"));
var ch_png_1 = __importDefault(require("./flags/ch.png"));
var cn_png_1 = __importDefault(require("./flags/cn.png"));
var de_png_1 = __importDefault(require("./flags/de.png"));
var es_png_1 = __importDefault(require("./flags/es.png"));
var fr_png_1 = __importDefault(require("./flags/fr.png"));
var global_png_1 = __importDefault(require("./flags/global.png"));
var in_png_1 = __importDefault(require("./flags/in.png"));
var it_png_1 = __importDefault(require("./flags/it.png"));
var jp_png_1 = __importDefault(require("./flags/jp.png"));
var kr_png_1 = __importDefault(require("./flags/kr.png"));
var mars_png_1 = __importDefault(require("./flags/mars.png"));
var mx_png_1 = __importDefault(require("./flags/mx.png"));
var my_png_1 = __importDefault(require("./flags/my.png"));
var nl_png_1 = __importDefault(require("./flags/nl.png"));
var nordics_png_1 = __importDefault(require("./flags/nordics.png"));
var pt_png_1 = __importDefault(require("./flags/pt.png"));
var ru_png_1 = __importDefault(require("./flags/ru.png"));
var sg_png_1 = __importDefault(require("./flags/sg.png"));
var th_png_1 = __importDefault(require("./flags/th.png"));
var uk_png_1 = __importDefault(require("./flags/uk.png"));
var us_png_1 = __importDefault(require("./flags/us.png"));
var za_png_1 = __importDefault(require("./flags/za.png"));
/**
 * FlagIcons assets
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/assets-flagicons--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/assets/flagIcons.ts Source}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/assets/flags Images}
 */
var flagIcons = {
    at: at_png_1.default,
    au: au_png_1.default,
    be: be_png_1.default,
    br: br_png_1.default,
    ca: ca_png_1.default,
    ch: ch_png_1.default,
    cn: cn_png_1.default,
    de: de_png_1.default,
    es: es_png_1.default,
    fr: fr_png_1.default,
    global: global_png_1.default,
    in: in_png_1.default,
    it: it_png_1.default,
    jp: jp_png_1.default,
    kr: kr_png_1.default,
    mars: mars_png_1.default,
    mx: mx_png_1.default,
    my: my_png_1.default,
    nl: nl_png_1.default,
    nordics: nordics_png_1.default,
    pt: pt_png_1.default,
    ru: ru_png_1.default,
    sg: sg_png_1.default,
    th: th_png_1.default,
    uk: uk_png_1.default,
    us: us_png_1.default,
    za: za_png_1.default,
};
exports.default = flagIcons;
